import { useCallback } from "react";
import { fetchPublicPathways } from "./learnerApi";
import useMemberRead from "./useMemberRead";

/**
 * `GET /public/pathways`: the practice's published pathways as cards (contract §5.2). No
 * session needed.
 *
 * Same read shape as the member hooks. A failed read is `error` and is never shown as "no
 * pathways yet", which is a different answer.
 */
export default function usePathwayCatalogue() {
  const fetcher = useCallback(() => fetchPublicPathways(), []);
  return useMemberRead(fetcher);
}
